module.exports = __webpack_public_path__ + "assets/GTAmerica-ExtendedBlack.ttf";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/fonts/GTAmerica-ExtendedBlack.ttf
// module id = 1007
// module chunks = 19